import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChartType } from 'components/query-charts/query-charts.types';
import { Message } from 'types/chat-messages';

type Axis = string | null;

export interface ChartDecision {
  chartType: ChartType;
  xAxis: Axis;
  yAxis: Axis;
  errorMessage?: string;
}

export type AiInquirerInit = {
  isLoading: boolean;
  isError: boolean;
  initContextMessages: Message[];
  response: string;
  functionArgsResponse: ChartDecision | null;
};

const initialState: AiInquirerInit = {
  isLoading: false,
  isError: false,
  initContextMessages: [],
  response: '',
  functionArgsResponse: null,
};

export const aiInquirerSliceName = 'aiInquirer';

export const aiInquirerSlice = createSlice({
  name: aiInquirerSliceName,
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<boolean>) => {
      state.isError = action.payload;
    },
    setInitContextMessages: (state, action: PayloadAction<Message[]>) => {
      state.initContextMessages = action.payload;
    },
    setResponse: (state, action: PayloadAction<string>) => {
      state.response = action.payload;
    },
    setFunctionArgsResponse: (state, action: PayloadAction<ChartDecision | null>) => {
      state.functionArgsResponse = action.payload;
    },
  },
});

export const { setLoading, setError, setInitContextMessages, setResponse, setFunctionArgsResponse } = aiInquirerSlice.actions;

export default aiInquirerSlice.reducer;
